// sof-ship-by — "Ships by <next business day>". Computed client-side so it's
// never frozen by page cache. Evaluated in America/New_York (Eastern) regardless
// of the shopper's timezone. Rule: ship days are Tue-Fri only. Ships the next
// ship day; after 4pm ET it's too late for next-day handoff so push one more
// day (Sat/Sun/Mon are skipped forward to Tuesday).
(function () {
  function compute() {
    var el = document.querySelector("[data-sof-ship-by]");
    var dateEl = document.querySelector("[data-sof-ship-date]");
    if (!el || !dateEl) return;
    // current wall-clock in Eastern (auto-handles EST/EDT)
    var et = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
    var afterCutoff = et.getHours() >= 16; // 4pm ET cutoff
    var d = new Date(et);
    d.setDate(et.getDate() + (afterCutoff ? 2 : 1));
    // We ship Tue-Fri only — skip Sat(6)/Sun(0)/Mon(1) forward to the next ship day.
    while (d.getDay() === 6 || d.getDay() === 0 || d.getDay() === 1) {
      d.setDate(d.getDate() + 1);
    }
    var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    dateEl.textContent = days[d.getDay()] + ", " + months[d.getMonth()] + " " + d.getDate();
    el.hidden = false;
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", compute);
  else compute();
  document.addEventListener("shopify:section:load", compute);
})();
